import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { Destacados } from "./Destacados";

export function StockDestacados({ studyId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!studyId) return;
    api.get("/indicadores/stock", { params: { study_id: studyId } })
      .then((r) => setItems(r.data.grupos.flatMap((g) => g.items).filter((i) => i.destacado).map((i) => ({ ...i, actual: i.value }))))
      .catch(() => setItems([]));
  }, [studyId]);
  return <Destacados items={items} to="/indicadores/stock" titulo="Indicadores clave de stock" testid="destacados-stock" />;
}
